import { render, staticRenderFns } from "./addSysMsg.vue?vue&type=template&id=c9a5d506"
import script from "./addSysMsg.vue?vue&type=script&lang=js"
export * from "./addSysMsg.vue?vue&type=script&lang=js"
import style0 from "./addSysMsg.vue?vue&type=style&index=0&id=c9a5d506&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports